import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import React, { useCallback, useRef, useState } from 'react'
import Autocomplete from '@mui/material/Autocomplete';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import {  Select, MenuItem, SelectChangeEvent } from '@mui/material';
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";



interface SearchItem {
  address: string;
  name: string;
  chain: string;
  symbol: string;
}

const CustomListbox = (props: any) => {
  return (
    <ul {...props} style={{ padding: 0, margin: 0 }}>
      {props.children}
    </ul>
  );
};

export default function GetStarted() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [searchResults, setSearchResults] = useState<SearchItem[]>([]);
  const [searchFilter, setSearchFilter] = useState<string>('All'); // Add this state for the dropdown filter
  const debounceTimer = useRef<NodeJS.Timeout | null>(null);
  var map: {[key:string]:string;}= {'All': 'All Chains', 'solana': 'Solana', 'eth': 'Ethereum', 'bsc': 'BSC', 'arbitrum': 'Arbitrum', 'avax': 'Avalanche',
  'base': 'Base','blast':'Blast','celo':'Celo','cro':'Cronos','ftm':'Fantom','xdai':'Gnosis','linea':'Linea','mantle':'Mantle','metis':'Metis',
  'optimism':'Optimism','polygon_pos':'Polygon','pulsechain':'Pulsechain','scroll':'Scroll','ton':'Ton','zksync':'ZKSync'
}
  const fetchSearchResults = useCallback((value: string) => {
    if (value !== '' && value.length > 2) {
      // Make an API request to fetch the matching items
      fetch(`https://tokenguide.io/api/search?q=${encodeURIComponent(value)}`)
        .then(response => response.json())
        .then((data: SearchItem[]) => {
          setSearchResults(data);
          console.log(data);
        })
        .catch(error => {
          console.error('Error:', error);
        });
    } else {
      setSearchResults([]);
    }
  }, []);

  const debounce = <T extends (...args: any[]) => void>(func: T, delay: number): ((...args: Parameters<T>) => void) => {
    return (...args: Parameters<T>) => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
      debounceTimer.current = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const debouncedFetchSearchResults = useCallback(
    debounce(fetchSearchResults, 500),
    [fetchSearchResults]
  );

  const handleSearchChange = (event: React.ChangeEvent<{}>, value: string) => {
    setSearchTerm(value);
    if (value === null || value.match(/^\s*$/) !== null) {
      setSearchResults([]);
    } else {
      debouncedFetchSearchResults(value);
    }
  };

  const handleFilterChange = (event: SelectChangeEvent<string>) => {
    const selectedFilter = event.target.value as string;
    setSearchFilter(selectedFilter);

    // Navigate to the corresponding URL based on the selected filter
  };

  const blast = require('../assets/blast.png');
  const gnosis = require('../assets/gnosis.png')
  const metis = require('../assets/metis.png')
  const pulsechain = require('../assets/pulsechain.png')
  const scroll = require('../assets/scroll.png')
  const ton = require('../assets/ton.png')

  return (
    <Box sx={{ marginLeft: { xs: '0', sm: '15%' }, textAlign: 'left', marginTop: '2.5%'}}>
      <Autocomplete<SearchItem, false, true, true>
        freeSolo
        disablePortal
        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name || '')}
        options={searchResults}
        ListboxComponent={CustomListbox}
        filterOptions={(options, { inputValue }) => {
          const filtered = options.filter((option) =>
            (option.name?.toLowerCase().includes(inputValue.toLowerCase()) ||
              option.address?.toLowerCase().includes(inputValue.toLowerCase())) &&
            (searchFilter === 'All' || option.chain === searchFilter)
          );
          return filtered;
        }}
        renderOption={(props, option) => (
          <ListItem
            color="#1C1D21"
            {...props}
            onClick={() => {
              navigate(`/tokens/${option.address}+${option.chain}`);
            }}
            sx={{
              backgroundColor: '#1C1D21',
              '&:hover': {
                zIndex: 1,
              },
            }}
            key={`${option.address},${option.chain}`}
          >
            <ListItemText
              primary={
                <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'white' }}>
                  {option.name} {`(${option.symbol})`}
                </Typography>
              }
              secondary={
                <Typography variant="body2" color="white">
                  {`${option.chain}:${option.address}`}
                </Typography>
              }
            />
          </ListItem>
        )}
        sx={{
          backgroundColor: '#1C1D21',
          borderRadius: 2,
          width: { xs: '100vw', sm: '40vw' },
          maxHeight:'5vh',
          '& + .MuiAutocomplete-popper .MuiAutocomplete-option:hover': {
            backgroundColor: '#2E9F7E',
          },
          '& .MuiAutocomplete-option:': {
            backgroundColor:'#1C1D21',
          },
      
        }}
        renderInput={(params) => (
          <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: { xs: '2vh', sm: '0' }, maxHeight:'5vh',}}>
            <Select
              value={searchFilter !== '' ? searchFilter : 'All'}
              onChange={handleFilterChange}
              renderValue={(selected) => (
                <ListItemText primary={map[searchFilter]}/>
              )}
              MenuProps={{
                PaperProps: {
                  sx: {
                    bgcolor: '#1C1D21',
                    maxHeight: '20vh',
                    overflowY:'auto',
                    maxWidth: {xs: '40vw'},
                    '& .MuiMenuItem-root': {
                      padding: 2,
                      color: 'white',
                      fontWeight: 'bold',
                      maxWidth: {xs: '35vw'},

                    },
                    "& .MuiMenuItem-root:hover": {
                      backgroundColor: "#2E9F7E"
                    },
                    "& .MuiMenuItem-root.Mui-selected:hover": {
                      backgroundColor: "#2E9F7E"
                    }
                  },
                },
              }}
              sx={{
                height: '5vh',
                minWidth: {xs:'27vw',sm: '9.25vw'},
                maxWidth:{xs:'27vw', sm:'20vw'},
                backgroundColor: 'white',
                '& .MuiSelect-select': {
                  paddingRight: '2rem',
                  maxWidth:{xs:'15vw', sm:'20vw'}
                },
              }}
            >
              <MenuItem value="All">
                All Chains
                </MenuItem>
<MenuItem value="solana">
  <ListItemIcon>
    <img
      src='/solana.svg'
      alt="Solana"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Solana" />
</MenuItem>

<MenuItem value="eth">
  <ListItemIcon>
    <img
      src="/eth.svg"
      alt="Ethereum"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Ethereum" />
</MenuItem>

<MenuItem value="bsc">
  <ListItemIcon>
    <img
      src={'/bsc.svg'}
      alt="BSC"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="BSC" />
</MenuItem>

<MenuItem value="arbitrum">
  <ListItemIcon>
    <img
      src="/arbitrum.svg"
      alt="Arbitrum"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Arbitrum" />
</MenuItem>

<MenuItem value="avax">
  <ListItemIcon>
    <img
      src="/avalanche.svg"
      alt="Avalanche"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Avalanche" />
</MenuItem>

<MenuItem value="base">
  <ListItemIcon>
    <img
      src="/base.svg"
      alt="Base"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Base" />
</MenuItem>

<MenuItem value="blast">
  <ListItemIcon>
    <img
      src={blast}
      alt="Blast"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Blast" />
</MenuItem>

<MenuItem value="celo">
  <ListItemIcon>
    <img
      src="/celo.svg"
      alt="Celo"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Celo" />
</MenuItem>

<MenuItem value="cro">
  <ListItemIcon>
    <img
      src="/cronos.svg"
      alt="Cronos"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Cronos" />
</MenuItem>

<MenuItem value="ftm">
  <ListItemIcon>
    <img
      src="/fantom.svg"
      alt="Fantom"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Fantom" />
</MenuItem>

<MenuItem value="xdai">
  <ListItemIcon>
    <img
      src={gnosis}
      alt="Gnosis"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Gnosis" />
</MenuItem>

<MenuItem value="linea">
  <ListItemIcon>
    <img
      src="/linea.svg"
      alt="Linea"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Linea" />
</MenuItem>

<MenuItem value="mantle">
  <ListItemIcon>
    <img
      src="/mantle.svg"
      alt="Mantle"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Mantle" />
</MenuItem>

<MenuItem value="metis">
  <ListItemIcon>
    <img
      src={metis}
      alt="Metis"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Metis" />
</MenuItem>

<MenuItem value="optimism">
  <ListItemIcon>
    <img
      src="/optimism.svg"
      alt="Optimism"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Optimism" />
</MenuItem>

<MenuItem value="polygon_pos">
  <ListItemIcon>
    <img
      src="/polygon.svg"
      alt="Polygon"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Polygon" />
</MenuItem>

<MenuItem value="pulsechain">
  <ListItemIcon>
    <img
      src={pulsechain}
      alt="Pulsechain"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Pulsechain" />
</MenuItem>

<MenuItem value="scroll">
  <ListItemIcon>
    <img
      src={scroll}
      alt="Scroll"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Scroll" />
</MenuItem>

<MenuItem value="ton">
  <ListItemIcon>
    <img
      src={ton}
      alt="Ton"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="Ton"/>
</MenuItem>

<MenuItem value="zksync">
  <ListItemIcon>
    <img
      src="/zksync.svg"
      alt="ZKSync"
      style={{ maxWidth: 24, maxHeight: 24, width: '100%', height: 'auto', borderRadius: '50%' }}
    />
  </ListItemIcon>
  <ListItemText primary="ZKSync" />
</MenuItem>




              {/* 
              <MenuItem value="aptos">Aptos</MenuItem>
              <MenuItem value="degenchain">DegenChain</MenuItem>
              <MenuItem value="dogechain">Dogechain</MenuItem>
              <MenuItem value="merlin-chain">Merlin</MenuItem>
              <MenuItem value="nrg">NRG</MenuItem> 
              <MenuItem value="ronin">Ronin</MenuItem>
              <MenuItem value="shibarium">Shibarium</MenuItem>
              <MenuItem value="sui-network">Sui</MenuItem>
               */}
              

            </Select>
            <TextField
              {...params}
              placeholder="Search by token name OR enter an address & chain"
              variant="outlined"
              size="medium"
              value={searchTerm}
              onChange={(event) => handleSearchChange(event, event.target.value)}
              sx={{
                backgroundColor: 'white',
                borderRadius: '0 4px 4px 0',
                width: { xs: '63vw', sm: '30vw' },
                '& .MuiInputBase-root': {
                  height: '5vh'
                },
              }}
              onKeyDown={(e) => {
                if (e.code === 'Enter' && (e.target as HTMLInputElement).value && searchTerm.length > 15 && searchFilter != 'All') {
                  navigate(`/tokens/${searchTerm}+${searchFilter}`);
                }
              }}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                ...params.InputProps,
                
                endAdornment: (
                  <InputAdornment position="end" sx={{ marginBottom: {xs:'1.5vh', sm:'1.5vh',md:'1vh',lg:'.25vh' }, marginRight: {xs:'-10vw', sm:'-1vw', md:'-1.5vw', lg:'-1vw'} }}>
                    {searchTerm.length > 15 && searchFilter != 'All' && (
                      <IconButton
                        sx={{ color: '#2E9F7E' }}
                        onClick={() => {
                          navigate(`/tokens/${searchTerm}+${searchFilter}`);
                        }}
                      >
                        <span style={{fontWeight: 'bold', fontSize: '1rem', marginRight: '.25vw', color: '#2E9F7E' }}>Search</span>
                        <SearchIcon />
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        )}
      />
    </Box>
  );
}